export const COMPONENT_NAME = "registration-verification";
